// extracted by mini-css-extract-plugin
export default {"wrapper":"Tooltip_wrapper__dmIof","tooltip":"Tooltip_tooltip__lKrqH","portalTooltip":"Tooltip_portalTooltip__i5+Ul"};